import { hc } from "hono/client";
import type { AppType } from "../functions/[[path]]";

// 타입 안전 클라이언트 생성
export const client = hc<AppType>("/");

// 사용 예시:
// const res = await client.api.sermons.latest.$get();
// const sermon = await res.json(); // SermonData 타입 자동 추론
